<template>
    <main-table-layout>
        <div slot="buttonsRight"/>
        <content-filter
                slot="filter"
                @filter="filter"
                :id="'projectList'"
                store-name="Project"
                :state-filter-items="Object.values(ProjectStates)"
                 :initial-state-filter="['a', 'i', 'p', 'h']"
        />
            <view-switcher
                    slot="mainContentButtons"
                :id="'mainContent'"
                :table="true"
                :thumbnails="true"
            />
        <pagination
                slot="mainContentButtons"
                :limit="paginationLimit"
                :total="$store.getters.getProjectListOptions('projectList', 'pagination_items')"
                :id="'projecttablepage'"
                @setActive="loadPaginatedData"
                ref="pagination"
        />
        <Button
            v-if="$store.getters.isSuperAdmin"
            permission="createProject"
            type="action-button" slot="mainContentButtons" link="/project/add" icon="plus">
                {{ $t('createNewProject') }}
        </Button>
<Button
           slot="mainContent"
           @click="loadPaginatedData(0); $refs.pagination.setActive(0)"
           type="reload"
           icon="redo"
           class="icon-button"
       />
            <table-widget
                    v-if="$store.getters.getViewSwitcher($route.name, 'mainContent') === 'table'"
                    slot="mainContent"
                    @sort="sort"
                    :id="'projectsDefaultTable'"
                    :nav-by-clicking-row="true"
                    :deletable="true"
                    @deleteRow="deleteRow"
                    :show-tags="true"
                    :show-organization="true"
                    :fields="tableFields"
                    :data="$store.getters.getProjects"
                    :title-as-links="true"
                    :key="forceReRenderKey"
                    edit-permission="write"
                    delete-permission="delete"
                    resource="Project"
                    :use-team-permission="true"
                    :show-state="$store.getters.isSuperAdmin"
                    :loading="loading"
            />
            <thumbnails
                    v-if="$store.getters.getViewSwitcher($route.name, 'mainContent') === 'thumbnails'"
                    slot="mainContent"
                    @sort="sort"
                    :id="'projectsDefaultThumbnails'"
                    :deletable="true"
                    @deleteRow="deleteRow"
                    :nav-by-clicking-row="true"
                     edit-permission="write"
                    delete-permission="delete"
                    :fields="thumbnailFields"
                    :data="$store.getters.getProjects"
                    :title-as-links="true"
                    :key="forceReRenderKey"
                    resource="Project"
                    :use-team-permission="true"
                    :show-state="$store.getters.isSuperAdmin"
                     :loading="loading"
            />
    </main-table-layout>
</template>

<script>
    import Button from "../components/forms/Button";
    import ContentFilter from "../components/widgets/filter/ContentFilter";
    import MainTableLayout from "../layouts/MainTableLayout";
    import ViewSwitcher from "../components/widgets/ViewSwitcher";
    import Thumbnails from "../components/widgets/ThumbnailView";
    import Pagination from "../components/Pagination";
    import { mapState } from 'vuex';
    import TableWidget from "@/components/widgets/TableWidget";
    import {ProjectStates} from "@/enum";
    export default {
        name: "Projects",
        components: {
            Button,
            TableWidget,
            ContentFilter,
            MainTableLayout,
            ViewSwitcher,
            Thumbnails,
            Pagination,
        },
        data() {
            return {
                ProjectStates: ProjectStates,
                loading: true,
                paginationLimit: 15,
                queryRelevantComponents: 2, //pagination and filter
                queryRelevantInits: 0,
                viewId: 'mainContent',
                forceReRenderKey: 0,
                sorting: '-updatedAt',
                tableFields: [
                    {
                        name: '',
                        id:'',
                        type: 'image',
                    },
                    {
                        name: 'Name',
                        id: 'name',
                        type: 'string',
                        sortable: true
                    },
                    {
                      name: 'Teams',
                      id: 'teams',
                      type: 'teams',
                    },
                    {
                        name: 'Last Update',
                        id: 'updatedAt',
                        type: 'date',
                        sortable: true
                    },
                    {
                        name: 'Edit',
                        type: 'editButton'
                    },
                ],
                thumbnailFields: [
                    {
                        name: '',
                        id:'',
                        type: 'image',
                    },
                    {
                        name: 'Organization',
                        id:'organization',
                        type: 'organization',
                    },
                    {
                        name: 'Last Update',
                        id: 'updatedAt',
                        type: 'date',
                        sortable: true
                    },
                    {
                        name: 'Name',
                        id: 'name',
                        type: 'string',
                        sortable: true
                    },
                  {
                    name: 'Teams',
                    id: 'teams',
                    type: 'teams',
                  },
                    {
                        name: 'Tags',
                        id:'tags',
                        type: 'tags',
                    },
                    {
                        name: 'Edit',
                        type: 'editButton'
                    },
                ],
            };
        },
        computed: mapState({pages: state => state.page.pages,}),
        watch: {
            queryRelevantInits: function(newval) {
                if(newval === this.queryRelevantComponents) {
                    this.loadPaginatedData(0);
                }
            }
        },
        methods: {
            loadPaginatedData: function(offset, initial) {
              this.loading = true;
                let args = {
                    add: {
                        paging: {
                            projectdefaultTable: true,
                        },
                        offset: {
                            projectdefaultTable: offset,
                        },
                        limit: {
                            projectdefaultTable: this.paginationLimit,
                        },
                        include: {
                            projectdefaultTable: ['tags','teams'],
                        },
                       sort: {
                          [this.listName]: this.sorting,
                        }
                    }
                };
                if(initial) {
                    this.queryRelevantInits++;
                    this.$store.dispatch('registerProjectsQueryParams', args);
                }
                else {
                    this.$store.dispatch('loadProjects', args).then(() => {
                      this.loading = false;
                    })
                }
            },
            deleteRow: function(id) {
                this.$store.dispatch('deleteProject', {
                    args: [id]
                });
            },
            filter: function (args, initial) {
                if(initial) {
                    this.queryRelevantInits++;
                    this.$store.dispatch('registerProjectsQueryParams', args);
                }
                else {
                  this.loading = true;
                    this.$store.dispatch('loadProjects', args).then(() => {
                      this.loading = false;
                    })
                }
            },
            setFilterParams: function(args) {
                this.$store.dispatch('submitQueryParams', {
                    storeType: 'organization',
                    listName: this.$route.params.id,
                    params: args,
                });
            },
             sort(args) {
              const {fieldname, direction} = args;
              const sortString = direction + fieldname;
              if(this.sorting !== sortString) {
                this.sorting = sortString;
              }
              this.loadPaginatedData(0);
            }
        }
    }
</script>
